import { format, parseISO, isValid } from "date-fns";

// Datetimes from the API are naive local strings ("YYYY-MM-DDTHH:MM:SS").
// Trim to seconds so they parse as local wall-clock time without any TZ shift.
const parse = (value) => {
  if (!value) return null;
  const date = parseISO(String(value).substring(0, 19));
  return isValid(date) ? date : null;
};

/** e.g. "Apr 30" */
export const formatListDate = (value) => {
  const date = parse(value);
  return date ? format(date, "MMM d") : "";
};

/** e.g. "10:00 AM" */
export const formatListTime = (value) => {
  const date = parse(value);
  return date ? format(date, "h:mm a") : "";
};

/** e.g. "Mar 28, 2026 · 2:10 PM" */
export const formatDateTimeLong = (value) => {
  const date = parse(value);
  return date ? format(date, "MMM d, yyyy · h:mm a") : "";
};

/** e.g. "Mar 28, 2026" */
export const formatDateLong = (value) => {
  const date = parse(value);
  return date ? format(date, "MMM d, yyyy") : "";
};

/** e.g. "9:00 AM – 11:00 AM" */
export const formatTimeRange = (start, end) => {
  const startDate = parse(start);
  if (!startDate) return "";
  const startStr = format(startDate, "h:mm a");
  const endDate = parse(end);
  return endDate ? `${startStr} – ${format(endDate, "h:mm a")}` : startStr;
};
